import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Input from '../TravellerContactInfo/FormFields/Input';
import { customStyles, UserFlowModalState } from '../UserFlow/UserFlowModal';
import './LoginModals.css';
import { If } from 'react-extras';

const initialStates = {
  showModal: true,
  validationFail: true,
  errorMessage: '',
};

const GetPasswordFailure = (props: UserFlowModalState) => {
  const [ state, setState ] = useState(initialStates);

  useEffect( () => {
    resolveErrorMessage();
  }, []);

  const closeModal = () => {
    setState({
      ...state,
      showModal: false,
    });
    props.closeModal();
  };

  const userNameVerified = () => {
    props.updateVerifiedUser(props.userStatus.userId);
  };

  const resolveErrorMessage = () => {
    const { error } = props.userStatus;
    if (error.includes('OTP')) {
      setState({
        ...state,
        errorMessage: 'You have sent too many password requests for this username.',
      });
    } else {
      setState({
        ...state,
        errorMessage: 'This phone number and username are not linked.',
      });
    }
  };

  const goToIRCTCRegistrationPage = () => {
    props.createAccount();
  };
  const { userStatus: { userId, mobileEntered }, switchModal, allowClose } = props;
  const { showModal, validationFail, errorMessage } = state;

  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className="loginModals htmlv2"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <div className="leftPanel">
        <p className="modalTitle font26 latoBloack blackText">
            Username Verified!
        </p>
        <p className="font20 latoBold darkGreyText appendBottom10">
            Do you remember your password?
        </p>
        <p className="font14 darkGreyText appendBottom30">
          Password is required by IRCTC for authentication after payment and <span className="redText">your booking might fail</span> if you don’t remember it.
        </p>
        <div className="makeFlex appendBottom50 end">
          <div className={`makeFlex column appendRight2 spaceBetween ${validationFail ? 'hrtlCenter' : 'end'}`}>
            <Input
              labelName="IRCTC USERNAME"
              errorMessage="Please enter OTP."
              validationFail={false}
              type="text"
              additionalAttributes={{ placeholder: userId }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg="Verified"
              vaidationMoreMsg="Change"
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly
              irctcUserId={userId}
              switchModal={switchModal}
              onChangePage="verifyUsername"
            />
          </div>
        </div>
        <p>
          <a className="font16 latoBold" onClick={userNameVerified}>Continue Booking</a>
        </p>
      </div>
      <div className="rightPanel">
        <If condition={allowClose === true}>
          <p className="textRight makeFlex spaceBetween start modalCloseCont">
            <span
              className="modalClose"
              onClick={closeModal}
            />
          </p>
        </If>

        <p className="font20 latoBold darkGreyText appendBottom10">Reset IRCTC Password</p>
        <p className="font14 appendBottom20">Enter the mobile number registered with your IRCTC account and get password (in 4-5 mins).</p>

        <div className="makeFlex spaceBetween end appendBottom10">
          <Input
            labelName="MOBILE NUMBER"
            errorMessage={errorMessage}
            validationFail
            type="text"
            additionalAttributes={{ placeholder: mobileEntered }}
            fieldId="IRCTCUserName"
            fieldName="IRCTCUserName"
            vaidationMsg=""
            vaidationMoreMsg="Change"
            vaidationMoreStatus={false}
            vaidationStatus
            readOnly
            irctcUserId={userId}
            mobileNumber={mobileEntered}
            switchModal={switchModal}
            onChangePage="forgotPassword"
          />
        </div>

        <div className="appendBottom30 end">

          <p className="font14 darkGreyText paddingT20 appendBottom5">Facing trouble?</p>
          <p className="appendBottom40"><a className="font16 latoBold " onClick={goToIRCTCRegistrationPage}>Create New Account</a></p>

        </div>
      </div>
    </Modal>
  );
};

export default GetPasswordFailure;
